import { createElement } from 'react';
const checkJssError = (props, component, optionalFieldCheckOnNull) => {
  const fields = props.fields;
  const dataSource = props.dataSource || props.rendering.dataSource;
  const componentName = props.componentName || props.rendering.componentName || props.params.eventAct;
  if (fields.errors) {
    console.warn(`${componentName} component render skipped. Error message ${fields.errors[0].message}`);
    return null;
  }
  if (dataSource.trim() === "") {
    console.warn(`${componentName} component render skipped. dataSource is empty`);
    return null;
  }
  if (optionalFieldCheckOnNull === null) {
    console.warn(`${componentName} component render skipped. required field return null`);
    return null;
  }
  return /*#__PURE__*/createElement(component, props);
};
export { checkJssError };